/* SWIFF — Gallery v2. No dependencies. GPU-friendly. */
(function () {
  'use strict';

  var R = window.SWIFF_ROUTES || {};
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var raf = window.requestAnimationFrame.bind(window);

  function money(cents) {
    var n = cents / 100;
    return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  /* ---------- 1. Opening ---------- */
  (function opening() {
    var ov = $('[data-ov]');
    if (!ov) return;
    if (!root.classList.contains('is-opening')) { ov.setAttribute('aria-hidden', 'true'); return; }
    var btn = $('[data-ov-enter]', ov), done = false;

    function enter() {
      if (done) return; done = true;
      try { sessionStorage.setItem('swiff:entered', '1'); } catch (e) {}
      root.classList.add('is-exiting', 'is-leaving');
      window.setTimeout(function () {
        root.classList.remove('is-opening', 'is-exiting');
        ov.setAttribute('aria-hidden', 'true');
        ov.style.display = 'none';
        doc.removeEventListener('keydown', onKey, true);
        var h1 = $('main h1');
        if (h1) { h1.setAttribute('tabindex', '-1'); h1.focus({ preventScroll: true }); }
      }, 850);
    }
    function onKey(e) {
      if (e.key === 'Tab') { e.preventDefault(); if (btn) btn.focus(); return; }
      if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); enter(); }
    }
    $$('[data-ov-enter],[data-ov-skip]', ov).forEach(function (b) { b.addEventListener('click', enter); });
    ov.addEventListener('wheel', enter, { passive: true, once: true });
    ov.addEventListener('touchmove', enter, { passive: true, once: true });
    doc.addEventListener('keydown', onKey, true);
    window.setTimeout(function () { if (btn && !done) btn.focus({ preventScroll: true }); }, 2400);

    var dust = $('[data-dust]', ov);
    if (dust && !reduce) {
      var frag = doc.createDocumentFragment();
      for (var i = 0; i < 26; i++) {
        var d = doc.createElement('i');
        d.style.left = (Math.random() * 100).toFixed(2) + '%';
        d.style.top = (Math.random() * 100).toFixed(2) + '%';
        d.style.setProperty('--dur', (16 + Math.random() * 18).toFixed(1) + 's');
        d.style.setProperty('--dly', (-Math.random() * 20).toFixed(1) + 's');
        d.style.setProperty('--dx', (Math.random() * 46 - 23).toFixed(0) + 'px');
        d.style.setProperty('--op', (0.22 + Math.random() * 0.45).toFixed(2));
        var sc = (0.7 + Math.random() * 1.5).toFixed(2);
        d.style.width = d.style.height = sc + 'px';
        frag.appendChild(d);
      }
      dust.appendChild(frag);
    }
  })();

  /* ---------- 2. Header ---------- */
  (function header() {
    var h = $('.site-header'); if (!h) return;
    var last = -1;
    function upd() { var s = window.scrollY > 24; if (s !== last) { h.classList.toggle('is-stuck', s); last = s; } }
    upd();
    window.addEventListener('scroll', function () { raf(upd); }, { passive: true });
  })();

  /* ---------- 3. Reveals ---------- */
  (function reveals() {
    var items = $$('.rv, .reveal');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) { items.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (e) { io.observe(e); });
  })();

  /* ---------- 4. Pointer depth ---------- */
  (function pointer() {
    if (reduce || window.matchMedia('(hover:none)').matches) return;
    var vit = $('[data-vitrine]');
    if (vit) {
      var vx = 0, vy = 0, cx = 0, cy = 0, tick = false;
      var loop = function () {
        cx += (vx - cx) * 0.09; cy += (vy - cy) * 0.09;
        vit.style.setProperty('--mx', cx.toFixed(4));
        vit.style.setProperty('--my', cy.toFixed(4));
        if (Math.abs(vx - cx) > 0.001 || Math.abs(vy - cy) > 0.001) raf(loop); else tick = false;
      };
      vit.addEventListener('pointermove', function (e) {
        var r = vit.getBoundingClientRect();
        vx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        vy = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!tick) { tick = true; raf(loop); }
      });
      vit.addEventListener('pointerleave', function () { vx = 0; vy = 0; if (!tick) { tick = true; raf(loop); } });
    }
    $$('[data-plate]').forEach(function (p) {
      var f = p.querySelector('.mat'); if (!f) return;
      p.addEventListener('pointermove', function (e) {
        var r = p.getBoundingClientRect();
        f.style.setProperty('--lx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        f.style.setProperty('--ly', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      });
      p.addEventListener('pointerleave', function () {
        f.style.setProperty('--lx', '50%'); f.style.setProperty('--ly', '16%');
      });
    });
  })();

  /* ---------- 5. Scroll parallax ---------- */
  (function worlds() {
    var els = $$('[data-par]');
    if (!els.length || reduce) return;
    var vis = [];
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var i = vis.indexOf(en.target);
        if (en.isIntersecting && i < 0) vis.push(en.target);
        else if (!en.isIntersecting && i > -1) vis.splice(i, 1);
      });
    }, { rootMargin: '80px' });
    els.forEach(function (e) { io.observe(e); });
    var pending = false;
    window.addEventListener('scroll', function () {
      if (pending || !vis.length) return; pending = true;
      raf(function () {
        var vh = window.innerHeight;
        vis.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          var t = el.querySelector('.mat') || el.querySelector('img');
          if (!t) return;
          t.style.setProperty('--par', (p * -26).toFixed(1) + 'px');
          if (t.tagName === 'IMG') t.style.transform = 'scale(1.12) translateY(' + (p * -26).toFixed(1) + 'px)';
        });
        pending = false;
      });
    }, { passive: true });
  })();

  /* ---------- 6. Rail ---------- */
  (function rail() {
    $$('[data-rail]').forEach(function (wrap) {
      var vp = $('[data-rail-vp]', wrap); if (!vp) return;
      var items = $$('.rail__item', vp); if (!items.length) return;
      var pending = false;
      function depth() {
        if (pending) return; pending = true;
        raf(function () {
          var r = vp.getBoundingClientRect(), mid = r.left + r.width / 2;
          items.forEach(function (it) {
            var ir = it.getBoundingClientRect();
            var d = ((ir.left + ir.width / 2) - mid) / (r.width / 2);
            d = Math.max(-1.4, Math.min(1.4, d));
            it.style.setProperty('--d', d.toFixed(3));
            it.style.setProperty('--ad', Math.abs(d).toFixed(3));
          });
          pending = false;
        });
      }
      if (!reduce) { depth(); vp.addEventListener('scroll', depth, { passive: true }); window.addEventListener('resize', depth); }
      var down = false, sx = 0, sl = 0, moved = 0;
      vp.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = 0; sx = e.clientX; sl = vp.scrollLeft; vp.classList.add('is-drag');
      });
      vp.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx; moved = Math.abs(dx); vp.scrollLeft = sl - dx;
      });
      function up() { if (!down) return; down = false; vp.classList.remove('is-drag'); }
      vp.addEventListener('pointerup', up); vp.addEventListener('pointerleave', up); vp.addEventListener('pointercancel', up);
      vp.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      $$('[data-rail-go]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var w = items[0].getBoundingClientRect().width + 22;
          vp.scrollBy({ left: b.dataset.railGo === 'next' ? w : -w, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  })();

  /* ---------- 7. Search overlay ---------- */
  (function search() {
    var s = $('[data-search]'); if (!s) return;
    var input = $('input[name="q"]', s), res = $('[data-search-res]', s), t = null, lastFocus = null;
    function open() {
      lastFocus = doc.activeElement;
      s.classList.add('is-open'); s.removeAttribute('aria-hidden');
      doc.body.style.overflow = 'hidden';
      window.setTimeout(function () { if (input) input.focus(); }, 120);
    }
    function close() {
      s.classList.remove('is-open'); s.setAttribute('aria-hidden', 'true');
      doc.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-search-close]', s).forEach(function (b) { b.addEventListener('click', close); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && s.classList.contains('is-open')) close(); });
    if (!input || !res) return;
    input.addEventListener('input', function () {
      window.clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { res.innerHTML = ''; return; }
      t = window.setTimeout(function () {
        fetch((R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var rs = (d.resources && d.resources.results) || {}, out = '';
            (rs.products || []).forEach(function (p) {
              var img = p.featured_image && p.featured_image.url;
              out += '<a class="srch__row" href="' + p.url + '"><span class="srch__thumb">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="mat m-stone"></span>') +
                '</span><span class="srch__t"><b>' + p.title + '</b><span>' + (p.type || 'Product') + '</span></span>' +
                '<span class="num">' + (p.price ? money(parseInt(p.price, 10)) : '') + '</span></a>';
            });
            (rs.collections || []).forEach(function (c) {
              out += '<a class="srch__row" href="' + c.url + '"><span class="srch__thumb"><span class="mat m-stone"></span></span>' +
                '<span class="srch__t"><b>' + c.title + '</b><span>Collection</span></span></a>';
            });
            res.innerHTML = out || '<p class="micro" style="padding:16px">No matches. Try a material — brass, linen, leather.</p>';
          })
          .catch(function () { res.innerHTML = ''; });
      }, 220);
    });
  })();

  /* ---------- 8. Mobile drawer ---------- */
  (function mnav() {
    var n = $('[data-mnav]'), b = $('[data-burger]'); if (!n || !b) return;
    b.addEventListener('click', function () {
      var open = n.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      doc.body.style.overflow = open ? 'hidden' : '';
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && n.classList.contains('is-open')) {
        n.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); doc.body.style.overflow = ''; b.focus();
      }
    });
  })();

  /* ---------- 9. Cart drawer ---------- */
  var Cart = (function () {
    var drawer = $('[data-cart]');
    var body = drawer && $('[data-cart-body]', drawer);
    var foot = drawer && $('[data-cart-foot]', drawer);
    var promptHTML = drawer ? (drawer.getAttribute('data-acct-prompt') || '') : '';

    function open() {
      if (!drawer) return;
      drawer.classList.add('is-open'); drawer.removeAttribute('aria-hidden');
      doc.body.style.overflow = 'hidden';
      var c = $('[data-cart-close]', drawer); if (c) c.focus();
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); doc.body.style.overflow = '';
    }
    function count(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; }); }

    function render(c) {
      count(c.item_count);
      if (!body) return;
      if (!c.items.length) {
        body.innerHTML = '<div class="cd__empty"><p>Nothing here yet.</p><a class="btn btn--sm" href="' +
          (R.all || '/collections/all') + '">Browse the collection</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      var rows = c.items.map(function (it, i) {
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">'
          : '<span class="mat m-stone"></span>';
        var vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : (it.product_type || '');
        return '<div class="cd__line" data-line="' + (i + 1) + '">' +
          '<a class="cd__thumb" href="' + it.url + '">' + img + '</a>' +
          '<div class="cd__info"><b><a href="' + it.url + '">' + it.product_title + '</a></b>' +
          (vt ? '<span>' + vt + '</span>' : '') +
          '<div class="cd__qty"><button type="button" data-q="-1" aria-label="Decrease quantity">&minus;</button>' +
          '<span aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" data-q="1" aria-label="Increase quantity">+</button></div>' +
          '<button class="cd__rm" type="button" data-rm>Remove</button></div>' +
          '<div class="num">' + money(it.final_line_price) + '</div></div>';
      }).join('');
      body.innerHTML = promptHTML + rows;
      var tot = $('[data-cart-total]', drawer);
      if (tot) tot.textContent = money(c.total_price);
    }

    function fetchCart(cb) {
      fetch((R.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c); if (cb) cb(c); })
        .catch(function () {});
    }
    function change(line, qty) {
      fetch((R.change || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render).catch(function () {});
    }

    if (drawer) {
      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); open(); fetchCart(); });
      });
      $$('[data-cart-close],[data-cart-scrim]', drawer).forEach(function (b) { b.addEventListener('click', close); });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
      if (body) body.addEventListener('click', function (e) {
        var line = e.target.closest('[data-line]'); if (!line) return;
        var n = parseInt(line.dataset.line, 10);
        var q = parseInt(line.querySelector('.cd__qty span').textContent, 10);
        if (e.target.closest('[data-rm]')) return change(n, 0);
        var qb = e.target.closest('[data-q]');
        if (qb) change(n, Math.max(0, q + parseInt(qb.dataset.q, 10)));
      });
    }
    return { open: open, close: close, fetch: fetchCart };
  })();

  /* ---------- 10. Add to cart ---------- */
  function fly(from) {
    if (reduce || !from) return;
    var target = $('[data-cart-open]'); if (!target) return;
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect();
    var g = from.cloneNode(true);
    g.className = 'fly';
    g.style.cssText += 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;opacity:.95;';
    doc.body.appendChild(g);
    raf(function () {
      raf(function () {
        g.style.transform = 'translate(' + (b.left + b.width / 2 - a.left - a.width / 2) + 'px,' +
          (b.top + b.height / 2 - a.top - a.height / 2) + 'px) scale(.08)';
        g.style.opacity = '0';
      });
    });
    window.setTimeout(function () { g.remove(); }, 820);
  }

  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-atc]'); if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding…</span>'; }
    var card = form.closest('.spec, .focus, .pdp');
    var plate = card && card.querySelector('.spec__plate, .focus__vis, .gallery__main');
    fetch(R.add || '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (!res.ok) {
          if (btn) { btn.innerHTML = '<span>' + (res.d.description || 'Unavailable') + '</span>'; window.setTimeout(function () { btn.innerHTML = label; }, 2400); }
          return;
        }
        fly(plate);
        window.setTimeout(function () { Cart.fetch(); Cart.open(); }, reduce ? 0 : 420);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* ---------- 11. Product gallery ---------- */
  (function gallery() {
    var main = $('[data-gallery-main] img');
    var thumbs = $$('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.full;
        main.alt = b.dataset.alt || '';
        thumbs.forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });
  })();

  /* ---------- 12. Variant selection ---------- */
  (function variants() {
    var data = window.SWIFF_VARIANTS;
    var form = $('[data-variant-form]');
    if (!data || !data.length || !form) return;
    var selects = $$('[data-option]', form);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = $('[data-variant-price]');
    var stockEl = $('[data-variant-stock]');
    var submit = form.querySelector('[data-variant-submit]');
    var stickyPrice = $('[data-sticky-price]');
    var stickyId = $('[data-sticky-id]');

    function match() {
      var chosen = selects.map(function (s) { return s.value; });
      for (var i = 0; i < data.length; i++) {
        var ok = true;
        for (var j = 0; j < chosen.length; j++) { if (data[i].options[j] !== chosen[j]) { ok = false; break; } }
        if (ok) return data[i];
      }
      return null;
    }
    function apply() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (stickyId) stickyId.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price
          ? '<s class="num">' + money(v.compare_at_price) + '</s>' : '') + '<span class="num">' + money(v.price) + '</span>';
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stockEl) {
        stockEl.classList.toggle('pdp__stock--out', !v.available);
        stockEl.textContent = v.available ? (stockEl.dataset.inLabel || 'In stock') : (stockEl.dataset.outLabel || 'Sold out');
      }
      if (submit) {
        submit.setAttribute('aria-disabled', v.available ? 'false' : 'true');
        var sp = submit.querySelector('span');
        if (sp) sp.textContent = v.available ? (submit.dataset.addLabel || 'Add to cart') : (submit.dataset.outLabel || 'Sold out');
      }
      if (window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (err) {}
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', apply); });
  })();

  /* ---------- 13. Sticky add-to-cart ---------- */
  (function stickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
  })();

  /* ---------- 14. Quantity steppers & cart page ---------- */
  doc.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = doc.getElementById(step.dataset.qtyStep);
      if (input) {
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.delta, 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    var line = e.target.closest('[data-qty]');
    if (line) {
      var i = line.dataset.qty;
      var f = doc.querySelector('[data-qty-input="' + i + '"]');
      if (f) {
        f.value = Math.max(0, (parseInt(f.value, 10) || 0) + parseInt(line.dataset.delta, 10));
        if (f.form) f.form.submit();
      }
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      e.preventDefault();
      var n = parseInt(rm.dataset.remove, 10);
      fetch((R.change || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: n, quantity: 0 })
      }).then(function () { window.location.reload(); });
    }
  });

  /* ---------- 15. Auto-submit filters ---------- */
  $$('[data-auto-submit]').forEach(function (s) {
    s.addEventListener('change', function () { if (s.form) s.form.submit(); });
  });

  /* ---------- 16. Boot ---------- */
  if (typeof window.SWIFF_CART_COUNT === 'number') {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = window.SWIFF_CART_COUNT; el.hidden = window.SWIFF_CART_COUNT === 0;
    });
  }
})();
